module.exports = __webpack_public_path__ + "static/media/КRU_ZETO_6_10.8567cb29.png";